export default __webpack_public_path__ + "static/media/epias-logo-white.c2a986fd.svg";